import axios from "axios";

const getters = {
    productsByCat: state => {
        if (state.products.length > 0) {
            let categories = new Object();
            state.categories.map(cat => (categories[cat.id] = []));
            state.products.map(product => {

                product.categories.map(cat => {
                    if (typeof categories[cat] != 'undefined') {

                        categories[cat].push(product);
                    }

                });
            });
            return categories;
        }
        return state.categoriesProducts;
    },
    productsByCatId: state => {
        let categories = new Object();
        state.categories.map(cat => (categories[cat.id] = []));
        state.products.map(product => {
            product.categories.map(cat => {
                if (typeof categories[cat] != 'undefined') {

                    categories[cat].push(product);
                }
            });
        });
        return categories;
    },
    categoriesBySlug: state => {
        let categories = new Object();
        state.categories.map(cat => (categories[cat.slug] = cat));
        return categories;
    },
    cartJSON: state => {
        var final_cart = [];
        for (var i in state.added) {
            final_cart.push({
                id: state.added[i].id,
                qu: state.added[i].quantity,
                note: state.added[i].note,
                type: state.added[i].selected,
                product_often: state.added[i].product_often,
                spread: state.added[i].spread ? state.added[i].selected : '',
				sale_price: state.added[i].salePriceTotal
            });
        }
        if (final_cart.length > 0) {

            return JSON.stringify(final_cart);
        } else {
            return false;

        }
    },
    allProducts: state => state.products, // would need action/mutation if data fetched async
    getNumberOfProducts: state => {
        if (state.added.length) {
            let counter = state.added.filter(product => {
                return !product.is_coupon_product;
            });
            return counter.length;
        }
        return 0;
    },
    cartProducts: state => {
        return state.products.filter(product => product.quantity > 0);
    },

    getLastProductForCart: state => {
        if (!state.lastProductId) {
            return false;
        }
        const product = state.products.find(p => p.id === state.lastProductId);
        return {
            product
        };
        //return this.$store.state.added[this.$store.state.added.length - 1];
    },
    getWeightText: state => product => {
        let weightNum = product.weight;
        let weightTxt = product.weight_type;
        if (weightNum < 1) {
            weightNum = weightNum * 1000;
            if (weightTxt == 'ק"ג') {
                weightTxt = "גרם";
            }
            if (weightTxt == "ליטר") {
                weightTxt = "מ״ל";
            }
        }
        return weightNum + " " + weightTxt;
    },
    getWeightTextOnly: state => product => {
        let weightTxt = product.weight_type;
        if (weightTxt == 'ק"ג') {
            weightTxt = "גרם";
        }
        if (weightTxt == "ליטר") {
            weightTxt = "מ״ל";
        }
        return weightTxt;
    },
    getSale: state => productId => {
        // bogo sales
        if (state.bogoSales) {
            let bogoSale = state.bogoSales.filter(p => {
                // console.log('sale2', p);
                if (p.product_buy.includes(parseInt(productId))) {
                    return p;
                }
                if (p.product_get === parseInt(productId)) {
                    return p;
                }
            });
            if (bogoSale !== null && typeof bogoSale !== "undefined" && bogoSale.length && bogoSale[0].active) {
                bogoSale[0].allowedMore = true;
                return bogoSale[0];
            }
        }
        if (state.sales) {
            if (typeof state.salesproduct[productId] == "undefined") {
                return false;
            }
            let productSaleCode = state.salesproduct[productId];

            let sale = state.sales.filter(p => {
                if (p.code == productSaleCode) {
                    return p;
                }
            });
            if (sale && sale.length > 0) {
                return sale[0];
            }

            return false;
        }
        return null;
    },
    getProductById: state => productId => {
        // deprecated code
        if (state.products.length) {
            let id =  state.products.find(p => p.id === parseInt(productId));
            if (id) {
                return id;
            }
        }
        // new code
        return axios({
            method: "GET",
            url: local_cache + "products/" + productId + ".json",
        }).then(res => {
            return res.data;
        }).catch(e => {
            return axios({
                method: "GET",
                url: cache_url + "products/" + productId + ".json",
            }).then(res => {
                return res.data;
            }).catch(e => {
                return e;
            });
        });

        // return axios({
        //     method: "GET",
        //     url: cache_url + "products/" + productId + ".json",
        // }).then(res => {
        //     return res.data;
        // }).catch(e => {
        //     console.log(e)
        // });
    },
    selectedText: state => product => {
        switch (product.selected) {
            case "full":
                return "שלם";
            case "spread":
                return "פרוס";
            case "unit":
                if (product.case) {
                    return "מארז";
                }
                return "יח׳";
            case "kg":
                return "ק״ג";
        }
    },
    unitPriceText: state => product => {
        switch (product.type) {
            case "unit":
                if (product.case) {
                    return "מארז";
                }
                return "יח׳";
            case "kg":
                return "ק״ג";
            case "both":
                return "ק״ג";
            case "unitaskg":
                return "ק״ג";
        }
    },
    getSlots: state => {
        return state.shipSlots;
    },
    orderEdit: state => {
        if (state.orderEdit) {
            return state.orderEditMeta;
        }
        return false;
    },
    userCheckoutInfo: state => {
        if (state.isAdmin && state.orderAs && typeof state.orderAs != 'undefiend') {
            return state.orderAs;
        }
        return state.userLoggedInfo;
    },
    formFields: state => name => {
        if (state.formFields[name]) {
            return state.formFields[name];
        } else {
            let formFields = localStorage.getItem('formFields');
            formFields = formFields === null ? {} : JSON.parse(formFields);
            if (formFields.hasOwnProperty(name)) {
                return formFields[name];
            }
        }
    },
    cartForGoogle: state => {
        var cart = [];
        state.added.map(product => {
            let productObj = {};
            var converted_quantity = product.selected == 'kg' ? Math.ceil(product.quantity / product.weight) : Math.ceil(product.quantity);
            var price = 0;
            if (
                typeof product.salePriceTotal != "undefined" &&
                product.salePriceTotal > 0
            ) {
                price = parseFloat(product.salePriceTotal).toFixed(2);
            }
            if ((product.type === "both" || product.type === "unitaskg") && product.selected === "unit") {
                price = parseFloat(
                    product.quantity * product.weight * product.price * product.divide_by
                ).toFixed(2);
            } else {
                price = parseFloat(product.quantity * product.price * product.divide_by).toFixed(2);
            }
            price = price / converted_quantity;
            productObj.id = product.id;
            productObj.name = product.name;
            productObj.quantity = converted_quantity;
            productObj.variant = product.selected == 'kg' ? 'kg' : 'unit';
            productObj.price = price;
            cart.push(productObj);
        })
        // state.cartForGoogle = cart;
        return cart;
    },
    pricePer100: state => product => {
        let price = parseFloat(product.price);

        if (["both","kg","unitaskg"].includes(product.type)) {
            price = price / 10;
        }
        else if (parseFloat(product.weight) > 0) {
            price = ( price * ( 1 / parseFloat(product.weight) ) ) / 10;
        } else {
            return false;
        }

        return price.toFixed(2);
    },
    pricePer100Text: (state, getters) => product => {
        let price = (getters.pricePer100(product) * product.divide_by).toFixed(2);
        return price + ' ₪ ל-100 ' + getters.getWeightTextOnly(product);
    },
    getCashbackPointsWorth: state => {
        return state.cashback.points / state.cashback.options.worth;
    },
    getCashbackUsedPointsWorth: state => {
        return state.cashback.process.pointsUsed / state.cashback.options.worth;
    },
    getLogoutText: () => {
        let text = 'יציאה';
        if (document.cookie.includes('impersonated_by')) {
            text = 'חזרה למשתמש שלי';
        }
        return text;
    },
    isLocalPickUp: state => {
        return state.localPickup;
    },
};
export default getters;
